module.exports = __webpack_public_path__ + "img/AsylumVol2.6f1cbcc5.jpeg";